export const BREAKPOINT = {
  TABLET: 1011,
  MOBILE: 767,
}

export const PADDING = 0.1

export const DITHERING_DEFAULT_DOT_OPACITY = 1
